export default __webpack_public_path__ + "static/Plots0099-7a35a44ca21dcfedf0be1c77f9ef07af.jpg";